export const STR_TEMPLATE_AVAILABLE = 'true';
export const STR_TEMPLATE_OBSOLETE = 'false';

export const STR_SERVICE_TEMPLATE_AVAILABLE = 'ACTIVE';
export const STR_SERVICE_TEMPLATE_OBSOLETE = 'OBSOLETE';

export const MAP_TARGET_TEMPLATE_STATUS = {
    [STR_TEMPLATE_AVAILABLE]: STR_TEMPLATE_OBSOLETE,
    [STR_TEMPLATE_OBSOLETE]: STR_TEMPLATE_AVAILABLE
}

export const MAP_TARGET_SERVICE_TEMPLATE_STATUS = {
    [STR_SERVICE_TEMPLATE_AVAILABLE]: STR_SERVICE_TEMPLATE_OBSOLETE,
    [STR_SERVICE_TEMPLATE_OBSOLETE]: STR_SERVICE_TEMPLATE_AVAILABLE
}

export const STR_DOWNLOAD_SPEED = 'downloadSpeed';
export const STR_UPLOAD_SPEED = 'uploadSpeed';
export const STR_TYPE = 'type';
export const STR_ONT = 'ont';
export const STR_METHOD = 'method';


export const STR_ONIVIA = 'ONIVIA';
export const STR_ONIVIA_SHORT = 'ONI';
export const STR_DOTS = '...';
export const STR_EMPTY = '';

export const PRODUCT_STATES = [
    { name: 'CREATED', value: 'CREATED' },
    { name: 'RESERVED', value: 'RESERVED' },
    { name: 'ACTIVE', value: 'ACTIVE' },
    { name: 'PROVISIONING', value: 'PROVISIONING' },
    { name: 'CANCELLED', value: 'CANCELLED' },
    { name: 'EXPIRED', value: 'EXPIRED' },
    { name: 'TERMINATED', value: 'TERMINATED' },
];

export const CFS_STATES = [
    { name: 'CREATED', value: 'CREATED' },
    { name: 'RESERVED', value: 'RESERVED' },
    { name: 'ACTIVE', value: 'ACTIVE' },
    { name: 'INSTALLED', value: 'INSTALLED' },
    { name: 'PROVISIONING', value: 'PROVISIONING' },
    { name: 'CANCELLED', value: 'CANCELLED' },
    { name: 'EXPIRED', value: 'EXPIRED' },
    { name: 'TERMINATED', value: 'TERMINATED' },
];

export const RFS_STATES = [
    { name: 'CREATED', value: 'CREATED' },
    { name: 'RESERVED', value: 'RESERVED' },
    { name: 'ACTIVE', value: 'ACTIVE' },
    { name: 'INSTALLED', value: 'INSTALLED' },
    { name: 'PROVISIONING', value: 'PROVISIONING' },
    { name: 'CANCELLED', value: 'CANCELLED' },
    { name: 'EXPIRED', value: 'EXPIRED' },
    { name: 'TERMINATED', value: 'TERMINATED' },
];

export const INFO_TYPES = [
    { name: 'PRODUCT', value: 'PRODUCT' },
    { name: 'CFS', value: 'CFS' },
    { name: 'RFS', value: 'RFS' },
];

export const RFS_ERRORS = [
    { name: 'SC_INTERNAL_ERROR', value: 'SC_INTERNAL_ERROR' },
    { name: 'SC_MISSING_RESPONSE', value: 'SC_MISSING_RESPONSE' },
    { name: 'SC_NOT_FOUND', value: 'SC_NOT_FOUND' },
    { name: 'REQ_UNKNOWN_OPERATION', value: 'REQ_UNKNOWN_OPERATION' },
    { name: 'REQ_FIELD_ERROR', value: 'REQ_FIELD_ERROR' },
    { name: 'REQ_FIELD_MISSING', value: 'REQ_FIELD_MISSING' },
    { name: 'REQ_OBJECT_MISSING', value: 'REQ_OBJECT_MISSING' },
    { name: 'MM_PARSE_ERROR', value: 'MM_PARSE_ERROR' },
    { name: 'MM_LOGIN_ERROR', value: 'MM_LOGIN_ERROR' },
    { name: 'MM_BAD_REQUEST', value: 'MM_BAD_REQUEST' },
    { name: 'MM_NO_RESPONSE', value: 'MM_NO_RESPONSE' },
    { name: 'MM_INTERNAL_ERROR', value: 'MM_INTERNAL_ERROR' },
    { name: 'ELD_PARSE_ERROR', value: 'ELD_PARSE_ERROR' },
    { name: 'ELD_EMPTY_RESPONSE', value: 'ELD_EMPTY_RESPONSE' },
    { name: 'ELD_ERROR_RESPONSE', value: 'ELD_ERROR_RESPONSE' },
    { name: 'F01', value: 'F01' },
    { name: 'F08', value: 'F08' },
    { name: 'F09', value: 'F09' },
    { name: 'F99', value: 'F99' },
    { name: 'SC_INTERNAL_ERR', value: 'SC_INTERNAL_ERR' },
];

export const ERROR_OPERATIONAL_STATES = [
    { name: 'NETWORK_ACTIVATION_FAILED', value: 'NETWORK_ACTIVATION_FAILED' },
    { name: 'NETWORK_TERMINATION_FAILED', value: 'NETWORK_TERMINATION_FAILED' },
    { name: 'NETWORK_MODIFICATION_FAILED', value: 'NETWORK_MODIFICATION_FAILED' },
    { name: 'CHANGECTO_ERROR_STATE', value: 'CHANGECTO_ERROR_STATE' }
];

export const ERROR_OPERATIONAL_STATES_RETRY_MAPPING = {
    NETWORK_ACTIVATION_FAILED: 'provision',
    NETWORK_TERMINATION_FAILED: 'provision',
    NETWORK_MODIFICATION_FAILED: 'provision',
    CHANGECTO_ERROR_STATE: 'provision'
};

export const CHARACTERISTICS_ORDER = [
    'sc_ftth_CTO_code',
    'sc_ftth_CTO_location',
    'sc_ftth_CTO_type',
    'sc_ftth_GPON_port',
    'sc_ftth_OLT_card_id',
    'sc_ftth_OLT_code',
    'sc_ftth_OLT_model',
    'sc_ftth_OLT_swVersion',
    'sc_ftth_ONT_id',
    'sc_ftth_ONT_password',
    'sc_ftth_Splitter_id',
    'sc_ftth_Splitter_location',
    'sc_ftth_Splitter_type',
    'sc_ftth_bw_download',
    'sc_ftth_bw_upload',
    'sc_ftth_client_address',
    'sc_ftth_client_segment',
    'sc_ftth_gescal',
    'sc_ftth_home_id',
    'sc_ftth_op_vlan',
    'sc_ftth_pPAI',
    'sc_ftth_remote_id',
    'sc_ftth_service_id',
    'sc_ftth_technology',
    'sc_ftth_template',
    'sc_ftth_territory_user',
    'sc_ftth_territory_owner',
    'sc_ftth_vertical_manager',
    'sc_ftth_s_vlan',
    'sc_ftth_a_vlan_1',
    'sc_ftth_a_vlan_2',
    'sc_ftth_a_vlan_3',
    'sc_ftth_a_vlan_4',
    'sc_ftth_a_vlan_5',
    'sc_ftth_c_vlan_1',
    'sc_ftth_c_vlan_2',
    'sc_ftth_c_vlan_3',
    'sc_ftth_c_vlan_4',
    'sc_ftth_c_vlan_5',
    'sc_ftth_modification_type',
    'sc_ftth_template_translated',
    'sc_ftth_home_id_translated',
    'sc_ftth_CDP_type',
    'sc_ftth_CDP_location',
    'sc_ftth_CDP_code',
    'sc_ftth_subvention_code',
    'sc_ftth_pw_id',
    'sc_ftth_client_cvlan',
    'sc_ftth_msm_subscriber_vlan605_id',
    'sc_ftth_msm_filter_vlan605_id',
    'sc_ftth_msm_filterrule_vlan605_id',
    'sc_ftth_trademark',
    'sc_ftth_msm_subscription_vlan605_id',
    'sc_ftth_eero_network_id',
    'sc_ftth_adamo_customer_type',
    'sc_network_home_id',
    'sc_network_remote_id',
    'sc_network_ppai',
    'sc_network_remote_id_tv',
    'sc_mobile_client_id',
    'sc_mobile_nationality',
    'sc_mobile_client_id_type',
    'sc_mobile_profile',
    'sc_mobile_external_id',
    'sc_mobile_billing_account_id',
    'sc_mobile_portin_number',
    'sc_mobile_portin_operator',
    'sc_mobile_portin_customer_name',
    'sc_mobile_portin_customer_identifier',
    'sc_mobile_portin_contract_type',
    'sc_mobile_portin_iccid',
    'sc_mobile_client_name',
    'sc_mobile_client_surname',
    'sc_mobile_contact_phone',
    'sc_mobile_contact_email',
    'sc_mobile_mm_account_id',
    'sc_mobile_iccid',
    'sc_ftth_CTO_port',
    'sc_mobile_mm_floor_optional',
    'sc_mobile_mm_country_key',
    'sc_mobile_mm_building_number',
    'sc_mobile_mm_street_type_key',
    'sc_mobile_mm_street',
    'sc_mobile_country_key',
    'sc_mobile_entrance_optional',
    'sc_mobile_mm_province',
    'sc_mobile_town',
    'sc_mobile_street',
    'sc_mobile_letter_optional',
    'sc_mobile_mm_entrance_optional',
    'sc_mobile_zip_code',
    'sc_mobile_mm_town',
    'sc_mobile_crm_id',
    'sc_mobile_crm_operation',
    'sc_mobile_floor_optional',
    'sc_mobile_mm_zip_code',
    'sc_mobile_province',
    'sc_mobile_street_type_key',
    'sc_mobile_building_number',
    'sc_mobile_mm_letter_optional',
    'sc_mobile_mm_profile_name',
    'sc_mobile_phone_number',
    'sc_mobile_transaction_id',
    'sc_mobile_modification_type',
    'sc_mobile_msisdn',
    'sc_mobile_eld_product_code',
    'sc_mobile_eld_status_id',
    'sc_mobile_eld_shipping_code',
    'sc_mobile_eld_status_description',
    'sc_mobile_eld_status_datetime',
    'sc_mobile_eld_tracking_url',
    'pc_ftth_bw_upload',
    'pc_ftth_technology',
    'pc_ftth_client_segment',
    'pc_ftth_ppai',
    'pc_ftth_territory_owner',
    'pc_ftth_home_id',
    'pc_ftth_bw_download',
    'pc_ftth_remote_id',
    'pc_ftth_territory_user',
    'pc_ftth_template',
    'pc_ftth_service_id',
    'pc_ftth_remote_id_tv',
    'sc_network_olt_swVersion',
    'sc_network_cto_location',
    'sc_network_op_vlan',
    'sc_network_splitter_location',
    'sc_network_cdp_code',
    'sc_network_cto_code',
    'sc_network_cdp_location',
    'sc_network_olt_card',
    'sc_network_vertical_manager',
    'sc_network_service_id',
    'sc_network_olt_port',
    'sc_network_ont_password',
    'sc_network_cto_type',
    'sc_network_cto_port',
    'sc_network_drop_cable_reutilise',
    'sc_network_olt_model',
    'sc_network_territory_owner',
    'sc_network_template',
    'sc_network_cdp_type',
    'sc_network_drop_cable_owner',
    'sc_network_splitter_type',
    'sc_network_splitter_id',
    'sc_network_client_active',
    'sc_network_technology',
    'sc_network_olt_code',
    'sc_network_ont_id',
    'sc_network_ont_model',
    'sc_network_olt_ip',
    'sc_network_olt_vendor',
    'sc_network_label',
    'sc_network_backup_cpe_model',
    'sc_mobile_mm_street_type_optional',
    'sc_mobile_portin_passport_country',
    'sc_mobile_mm_profile',
    'sc_mobile_unsubscribe_document',
    'sc_mobile_mm_status',
    'sc_mobile_mm_block_optional',
    'sc_mobile_mm_status_calls_out',
    'sc_mobile_mm_additional_bond',
    'sc_mobile_mm_status_calls_in',
    'sc_mobile_mm_status_data',
    'sc_mobile_mm_status_sms_in',
    'sc_mobile_client_id_document',
    'sc_mobile_additional_bond',
    'sc_mobile_mm_status_premium',
    'sc_mobile_mm_hand_optional',
    'sc_mobile_mm_status_roaming',
    'sc_mobile_mm_km_optional',
    'sc_mobile_mm_additional_bond_name',
    'sc_mobile_mm_status_sms_out',
    'sc_mobile_business_name',
    'sc_mobile_mm_init_date',
    'sc_mobile_portin_customer_id_type',
    'sc_mobile_mm_stair_optional',
    'sc_mobile_mm_requested_portability_date',
    'sc_mobile_mm_asset_id',
    'sc_mobile_mm_portal_door_optional',
    'sc_mobile_additional_bond_qty',
    'sc_mobile_mm_creation_date',
    'sc_mobile_client_full_name',
    'sc_mobile_mm_no_return_date',
    'sc_mobile_replace_document',
    'sc_mobile_unsubscribe_reason',
    'sc_mobile_mm_country_optional',
    'sc_mobile_mm_region_optional',
    'sc_mobile_mm_estimated_delivery_date',
    'sc_mobile_mm_order_id',
    'sc_mobile_km_optional',
    'sc_mobile_stair_optional',
    'sc_mobile_eld_notes',
    'sc_mobile_eld_requested_delivery_date',
    'sc_mobile_authorized_name',
    'sc_mobile_street_type_optional',
    'sc_mobile_hand_optional',
    'sc_mobile_solution_type',
    'sc_mobile_portal_door_optional',
    'sc_mobile_authorized_surname',
    'sc_mobile_authorized_id',
    'sc_mobile_authorized_id_type',
    'sc_mobile_block_optional',
    'sc_mobile_country_optional',
    'sc_mobile_region_optional',

    'sc_ftth_apartment_id',
    'sc_ftth_apartment_lat',
    'sc_ftth_apartment_lng',
    'sc_ftth_billing_account_id',
    'sc_ftth_building_number',
    'sc_ftth_client_full_name',
    'sc_ftth_contact_phone',
    'sc_ftth_crm_id',
    'sc_ftth_external_id',
    'sc_ftth_floor',
    'sc_ftth_hand',
    'sc_ftth_network_segment_name',
    'sc_ftth_project_code',
    'sc_ftth_province',
    'sc_ftth_static_ip_req',
    'sc_ftth_street',
    'sc_ftth_street_type',
    'sc_ftth_town',
    'sc_ftth_voip_lines_count',
    'sc_ftth_voip_password',
    'sc_ftth_voip_service_id',
    'sc_ftth_voip_username',
    'sc_ftth_zip_code',
    'sc_network_client_segment',
    'sc_network_territory_user',
    'sc_ftth_msm_network_segment_id',
    'sc_ftth_msm_required',
    'sc_ftth_msm_service_name',
    'sc_ftth_msm_service_id',
    'sc_ftth_msm_service_filter_id',
    'sc_ftth_msm_subscriber_id',
    'sc_ftth_msm_subscription_id',
    'sc_ftth_address_state_id',
    'sc_ftth_address_state_name',
    'sc_ftth_ams_apartment_id',
    'sc_ftth_ams_site_id',
    'sc_ftth_bis',
    'sc_ftth_block',
    'sc_ftth_letter',
    'sc_ftth_portal_door',
    'sc_network_cto_i',
    'sc_ftth_voip_2_password',
    'sc_ftth_stair',
    'sc_ftth_ip_vlan603_id',
    'sc_ftth_ip_vlan605_id',
    'sc_ftth_ip_vlan603',
    'sc_ftth_ip_vlan605',
    'sc_ftth_voip_2_service_id',
    'sc_ftth_ip_vlan603_mac',
    'sc_ftth_ip_vlan603_name',
    'sc_ftth_ip_vlan605_name',
    'sc_ftth_voip_2_username',
    'sc_ftth_voip_vlan604',
    'sc_ftth_voip_vlan631',
    'sc_ftth_voip_vlan605',
    'sc_network_cpe_model',
    'sc_ftth_main_partner',
    'sc_ftth_customer_type',
    'sc_ftth_sales_area',
    'sc_network_installation_type',
    'sc_network_svlan',
    'sc_network_territory_owner_name',
    'sc_ftth_cgnat_enabled',
    'sc_ftth_vlan631_enabled',
    'sc_ftth_acs_required',
    'sc_ftth_contact_email'
];

export const ORDER_OPERATIONAL_STATES = [
    { name: 'Waiting for FTTH', value: 'Waiting for FTTH' },
    { name: 'Init', value: 'Init' },
    /*{ name: 'Ready', value: 'Ready' },*/
    { name: 'Shipping started', value: 'Shipping started' },
    { name: 'ICC notified', value: 'ICC notified' },
    { name: 'Shipping end', value: 'Shipping end' },
    { name: 'Mobile Account created', value: 'Mobile Account created' },
    { name: 'Mobile New Line requested', value: 'Mobile New Line requested' },
    { name: 'Mobile Portability Line requested', value: 'Mobile Portability Line requested' },
    { name: 'Mobile New completed', value: 'Mobile New completed' },
    { name: 'Mobile Portability completed', value: 'Mobile Portability completed' },
    { name: 'Must be escalated to MM', value: 'Must be escalated to MM' },
    { name: 'Evaluate Full Relaunch', value: 'Evaluate Full Relaunch' },
    { name: 'Waiting for ICCID from Installer', value: 'Waiting for ICCID from Installer' }
];

export const ORDER_STATES = [
    { name: 'ACK', value: 'ACK' },
    { name: 'CANCELLED', value: 'CANCELLED' },
    { name: 'CANCELLING', value: 'CANCELLING' },
    { name: 'CANCELLING_HELD', value: 'CANCELLING_HELD' },
    { name: 'COMPLETED', value: 'COMPLETED' },
    { name: 'CREATED', value: 'CREATED' },
    { name: 'FAILED', value: 'FAILED' },
    { name: 'HELD', value: 'HELD' },
    { name: 'INPROGRESS', value: 'INPROGRESS' },
    { name: 'PARTIAL', value: 'PARTIAL' },
    { name: 'PENDING', value: 'PENDING' },
    { name: 'SAVED', value: 'SAVED' }
];


export const ORDER_ACTIONS = [
    { name: 'Alta', value: 'add' },
    { name: 'Baja', value: 'delete' },
    { name: 'Modificación', value: 'update_rfs' },
    { name: 'Reprovisión', value: 'reprovision' }
];

export const TASK_CUSTOM_SEARCH_KEYS = [
    { name: 'Código error', value: 'errorCode' },
    { name: 'Descripción error', value: 'errorDescription' },
    { name: 'Operación', value: 'activity' },
    { name: 'Id de servicio', value: 'orderId' },
    { name: 'CRM Id', value: 'businesscrmid' },
    { name: 'Proceso', value: 'idproceso' }
];


export const TASK_TYPES = [
    { name: 'Incidencia de datos (SCAI Error)', value: 'scai_error' },
    { name: 'Error técnico (Technical Error)', value: 'technical_error' },
    { name: 'Incidencia de facturación (Billing Error)', value: 'billing_error' },
    { name: 'Error técnico de facturación (Technical Billing Error)', value: 'technical_billing_error' }
];

export const NOTIFICATION_TARGET_SYSTEMS = [
    { name: 'INFONOVA', value: 'INFONOVA' },
    { name: 'ADAMO-SMS-API', value: 'ADAMO-SMS-API' }
];

export const RESOURCES_LEVEL = [
    { name: 'OLT', level: 1 },
    { name: 'OLT Slot', level: 2 },
    { name: 'OLT Port', level: 3 },
    { name: 'CTO', level: 4 },
    { name: 'Splitter', level: 5 },
    { name: 'Puerto', level: 5 }
  ];
